<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-xsmall-size-50">
      <md-card >
        <form novalidate @submit.prevent="validateUser">
          <md-card-header>
            <md-card-header-text>
              <div class="md-title" v-if="instance.id">Editando banco</div>
              <div class="md-title" v-if="!instance.id">Crear banco</div>
            </md-card-header-text>
            <md-menu md-size="big" md-direction="bottom-end">
              <md-button class="md-icon-button" @click="go_to(`/banks/`)">
                <md-icon>keyboard_backspace</md-icon>
              </md-button>
            </md-menu>
          </md-card-header>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field :class="getValidationClass('name')">
                  <label for="name">Nombre</label>
                  <md-input
                  v-model="instance.name"
                  :disabled="sending" />
                  <span class="md-error" v-if="!$v.instance.name.required">
                    El nombre del banco es requerido.
                  </span>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100">
                <md-field>
                  <label for="phone">Teléfono</label>
                  <md-input type="number"
                  autocomplete="phone" v-model="instance.phone" :disabled="sending" />
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100">
                <md-field :class="getValidationClass('address')">
                  <label for="address">Dirección</label>
                  <md-input type="text" autocomplete="address"
                  v-model="instance.address" :disabled="sending" />
                  <span class="md-error"
                  v-if="!$v.instance.address.required">La dirección es requerida</span>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100">
                <md-field>
                  <label for="email">Correo eléctronico</label>
                  <md-input type="email"
                  v-model="instance.email" :disabled="sending" />
                </md-field>
              </div>
            </div>
          </md-card-content>
          <md-progress-bar md-mode="indeterminate" v-if="sending" />
          <md-card-actions>
            <md-button
            type="submit" class="md-primary" :disabled="sending">Guardar cambios</md-button>
          </md-card-actions>
        </form>
      </md-card>
      <br>
      <br>
    </div>
    <md-snackbar
      :md-active.sync="userSaved">{{ message }} ha sido actualizado!</md-snackbar>
  </div>
</template>
<script>
/* eslint-disable */
import { validationMixin } from 'vuelidate'
import {
  required,
  email,
} from 'vuelidate/lib/validators'

export default {
  name: 'Form_bank',
  created(){
    if  (this.$route.params.id) {
      this.instance.id = this.$route.params.id
      this.retrieve();
    }
  },
  mixins: [validationMixin],
  data() {
    return {
      logo_url: '',
      base: process.env.VUE_APP_BASE_URL,
      instance: {
        name: null,
        email: '',
        address: 'CUIDAD',
        phone: '',
      },
      url: 'banks/',
      userSaved: false,
      sending: false,
      message: null
    };
  },
  validations: {
    instance: {
      name: {
        required,
      },
      address: {
        required,
      },
    },
  },
  methods: {
    go_to(url) {
      this.$router.push(url);
    },
    save_storage(key, data) {
      localStorage.setItem([key], JSON.stringify(data));
    },
    set_logo(document_id) {
      let payload = {}
      payload.change_logo = 'True'
      payload.id = this.instance.id
      payload.url = document_id
      const self = this;
      this.retrieveRequest(this.url, payload).then((data) => {
        self.instance = data.data
        self.$swal.fire('Actualizado', 'Actualización exitosa.', 'success');
      }).catch((error) =>{
        this.handlerError(error)
      });
    },
    handlerError: (error) => {
      const result = error.response.data;
      const self = this;
      if (typeof (error.response.data) === 'object') {
        Object.entries(result).forEach(([key, value]) => { window.$swal.fire('Error!', `${key}: ${value}`, 'error'); });
        return false;
      }
      self.$swal.fire('Error!', result, 'error');
      return false;
    },
    list() {
      const payload = {};
      const self = this;
      this.sendRequest(payload, this.url).then((data) => {
        self.list_data = data.data;
      }).catch((error) => {
        console.log(error);
        self.$swal.fire('Error!', 'No fue posible obtener los registros.', 'error');
      });
      return null;
    },
    getValidationClass (fieldName) {
      const field = this.$v.instance[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
    },
    validateUser () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saveOrUpdate()
      }
    },
    saveOrUpdate () {
      if (!this.instance.name) {
        this.$swal.fire('Error!', 'El nombre es requerido.', 'error')
        return false
      }
      const payload = this.instance
      const self = this
      this.sending = true
      if (this.instance.id) {
        this.putRequest(payload).then(function (data) {
          self.message = `${self.instance.name}`
          self.userSaved = true
          self.sending = false
          self.instance = data.data
          self.clearForm()
        }).catch(function (error) {
          self.sending = false
          if (typeof (error.response.data) === 'object') {
            const result = error.response.data
            Object.entries(result).forEach(
              ([key, value]) => self.$swal.fire('Error!', key + ': ' + value, 'error')
            )
            return false
          }
          self.$swal.fire('Error!', error.response.data, 'error')
        })
        return
      }
      payload.company = localStorage.getItem('office')
      if (!payload.company) {
        this.$swal.fire('Error!','La empresa es requerida' , 'error')
        return
      }
      if (this.$store.state.store_obj) {
        payload.store = this.$store.state.store_obj.id
      }
      
      this.postRequest(payload).then(function (data) {
        self.message = `${self.instance.name}`        
        self.userSaved = true
        self.sending = false
        self.instance = data.data
      }).catch(function (error) {
        self.sending = false
        if (typeof (error.response.data) === 'object') {
          const result = error.response.data
          Object.entries(result).forEach(
            ([key, value]) => self.$swal.fire('Error!', key + ': ' + value, 'error')
          )
          return false
        }
        self.$swal.fire('Error!', error.response.data, 'error')
      })
    },
    async retrieve () {
      const self = this
      const payload = {
        id: this.instance.id,
        basic_serializer: 'True'
      }
      await this.retrieveRequest(this.url, payload).then(function (data) {
        self.instance = data.data
      }).catch(function (error) {
        self.handlerError(error)
      })
    },
    async sendRequest(payload, url) {
      const result = await this.$http.get(url,{params:  payload});
      return result;
    },
    async postRequest (payload) {
      const result = await this.$http.post(this.url, payload)
      return result
    },
    async putRequest (payload) {
      const result = await this.$http.put(`${this.url}${payload.id}/`, payload)
      return result
    },
    async retrieveRequest (url, _payload) {
      const result = await this.$http.get(url + _payload.id + '/', { params: _payload })
      return result
    },
  },
  filters: {
    status_to_text(value){
      if (value) return 'Sí';
      return 'No';
    }
  },
  computed: {
    settings_obj() {
      return this.$store.state.settings_obj;
    },
  },
};

</script>
<style lang="css" scoped>
 .success {
    font-weight: 500;
    background-color: #4aad09;
  }
  .warning {
    font-weight: 500;
    background-color: yellow;
  }
  .danger {
    font-weight: 500;
    background-color: red;
  }
  table {
    font-size: 2em;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-box-shadow: 0 0 0px 1000px #424242 inset;
  }
</style>
